
const state = {
    saleItems: [],
    selectedSaleItemIndex: null,
    selectedSaleItem: {},
    totalSaleAmount: null,
    newSaleItem: {
        id: null,
        name: null,
        color: null,
        displacement: null,
        result: null,
        commission: null,
        auction_fee: null,
        inland_transport: null,
        discount: null,
        total: null,

    }
}

const getters = {
    getProformaInvoiceSaleItems: (state) => {
        return state.saleItems
    },
    getProformaInvoiceSelectedSaleItem: (state) => {
        return state.selectedSaleItem
    },
    getProformaInvoiceTotalSaleAmount: (state) => {
        return state.totalSaleAmount
    },
    getProformaInvoiceNewSaleItem: (state) => {
        return state.newSaleItem
    }
}

const mutations = {
    setProformaInvoiceSaleItems: (state, newItems) => {
        state.saleItems = newItems
    },
    setProformaInvoiceSelectedSaleItem: (state, newItem) => {
        state.selectedSaleItem = newItem
    },
    setProformaInvoiceSelectedSaleItemIndex: (state, newItem) => {
        state.selectedSaleItemIndex = newItem
    },
    setProformaInvoiceSelectedSaleItemFieldValue: (state, data) => {
        state.selectedSaleItem[data.field] = data.value
    },
    setProformaInvoiceNewSaleItemFieldValue: (state, data) => {
        state.newSaleItem[data.field] = data.value
    },
    pushNewProformaInvoiceNewSaleItem: (state) => {
        state.saleItems.push(state.newSaleItem)
        state.newSaleItem = {
            id: null,
            name: null,
            color: null,
            displacement: null,
            result: null,
            commission: null,
            auction_fee: null,
            inland_transport: null,
            discount: null,
            total: null,
        }
    },
    setProformaInvoiceTotalSaleAmount: (state) => {
        let newValue = 0
        state.saleItems.forEach(function(element) {
            newValue = Number(newValue) + Number(element.total)
        })
        state.totalSaleAmount = newValue

    },
    replaceProformaInvoiceSaleItemWithSelectedSaleItem: (state) => {
        state.saleItems[state.selectedSaleItemIndex] = state.selectedSaleItem
        state.selectedSaleItem = {}
    },
    removeProformaInvoiceSaleItem: (state, item) => {
        state.saleItems = state.saleItems.filter(i => i !== item)
    }
}

const actions = {
    changeProformaInvoiceTotalSaleAmount: ({ commit }) => {
        commit('setProformaInvoiceTotalSaleAmount')
    },
    changeProformaInvoiceSaleItems: ({ commit }, newItems) => {
        commit('setProformaInvoiceSaleItems', newItems)
    },
    changeProformaInvoiceSelectedSaleItem: ({ commit }, newItem) => {
        commit('setProformaInvoiceSelectedSaleItem', newItem)
    },
    changeProformaInvoiceSelectedSaleItemIndex: ({ commit }, newItem) => {
        commit('setProformaInvoiceSelectedSaleItemIndex', newItem)
    },
    changeProformaInvoiceSelectedSaleItemFieldValue: ({ commit }, newFieldValue) => {
        commit('setProformaInvoiceSelectedSaleItemFieldValue', newFieldValue)
    },
    changeProformaInvoiceNewSaleItemFieldValue: ({ commit }, newFieldValue) => {
        commit('setProformaInvoiceNewSaleItemFieldValue', newFieldValue)
    },
    updateProformaInvoiceSaleItem: ({ commit }) => {
        commit('replaceProformaInvoiceSaleItemWithSelectedSaleItem')
    },
    saveProformaInvoiceSaleItem: ({ commit }) => {
        commit('pushNewProformaInvoiceNewSaleItem' )
    },
    deleteProformaInvoiceSaleItem: ({ commit }, item) => {
        commit('removeProformaInvoiceSaleItem', item)
    }
}


export default { state, getters, mutations, actions }




// WEBPACK FOOTER //
// ./src/store/modules/proformaInvoiceSalesItems.js